import TutorialListView from '../../components/TutorialListView';

TutorialListScreen.propTypes = {};

function TutorialListScreen(props) {
    return (
        <div className="container-fluid px-4 my-4">
            <TutorialListView showFullUI={true} />
        </div>
    );
}

export default TutorialListScreen;
